import styled from "@emotion/styled";

export const GoodOnYouLabel = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.fontSize14};
  font-weight: ${({ theme }) => theme.fontWeights.body};
  line-height: ${({ theme }) => theme.text.body.source.regular14.lineHeight};
  padding-bottom: ${({ theme }) => theme.space.space16};
  color: ${({ theme }) => theme.colors.tone.anthracite};
  a {
    cursor: pointer;
    text-decoration: underline;
  }
`;

export const SearchWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${({ theme }) => theme.space.space16};
  padding-bottom: ${({ theme }) => theme.space.space16};
`;

export const FavoriteBrandsWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.tone.sand};
  padding: ${({ theme }) => theme.space.space16};
  margin-inline: ${({ theme }) => `-${theme.space.space16 || "16px"}`};
`;
